import React, { type JSX } from 'react';
import { Play, Square, Settings, CheckCircle } from 'lucide-react';

export const EventIcon = ({ eventType }: { eventType: string }): JSX.Element => {
  const iconProps = {
    className: 'size-3',
    strokeWidth: 2.5,
    style: { color: 'rgb(100, 116, 139)' }
  };

  switch (eventType) {
    case 'FlowStart':
      return <Play {...iconProps} />;
    case 'FlowEnd':
      return <Square {...iconProps} />;
    case 'Parameters':
      return <Settings {...iconProps} />;
    case 'ExecutionResult':
      return <CheckCircle {...iconProps} />;
    default:
      return <div className='size-3 rounded-full' style={{ backgroundColor: 'rgb(148, 163, 184)' }} />;
  }
};
